import { Col, Form, FormGroup, Row } from 'react-bootstrap';
import React, { ChangeEvent, Fragment } from 'react';
import IActivity from 'interfaces/IActivity';

interface IActivityEntry {
    activity?: IActivity;
    index?: number;
    handleInputChange: (name: string, value: string | number) => void;
    showAge?: boolean;
}

const today = new Date().toISOString().split('T')[0];

const ActivityEntry: React.FC<IActivityEntry> = ({ activity, index = -1, handleInputChange }) => {
    const checkValid = (input: any) => input !== undefined && !!input;
    const checkInvalid = (input: any) => input !== undefined && !input;

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) =>
        handleInputChange(e.target.name, e.target.value);

    const handleOnChangeNumber = (e: ChangeEvent<HTMLInputElement>) =>
        handleInputChange(e.target.name, Number(e.target.value));

    // @ts-ignore
    return (
        <Fragment key={`activity-${index}`}>
            <Row className="mb-3 text-black">
                <Col xs={9}>
                    <FormGroup
                        key={`activity[${index}].eventAndTitle`}
                        controlId={`activity[${index}].eventAndTitle`}
                    >
                        <Form.Label className="h4">Event & Title</Form.Label>
                        <Form.Control
                            name="eventAndTitle"
                            value={activity?.eventAndTitle || ''}
                            required
                            onChange={handleOnChange}
                            autoFocus={true}
                            isValid={checkValid(activity?.eventAndTitle)}
                            isInvalid={checkInvalid(activity?.eventAndTitle)}
                        />
                    </FormGroup>
                </Col>

                <Col xs={3}>
                    <FormGroup
                        key={`activity[${index}].date`}
                        controlId={`activity[${index}].date`}
                    >
                        <Form.Label className={'h4'}>Date</Form.Label>
                        <Form.Control
                            name="date"
                            value={activity?.date || ''}
                            type="date"
                            max={today}
                            min="1950-01-01"
                            required
                            //@ts-ignore
                            onChange={handleOnChange}
                            isValid={checkValid(activity?.date)}
                            isInvalid={checkInvalid(activity?.date)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3 text-black">
                <Col xs={12}>
                    <FormGroup
                        key={`activity[${index}].provider`}
                        controlId={`activity[${index}].provider`}
                    >
                        <Form.Label className="h4">Provider</Form.Label>
                        <Form.Control
                            name="provider"
                            value={activity?.provider || ''}
                            onChange={handleOnChange}
                            required
                            isValid={checkValid(activity?.provider)}
                            isInvalid={checkInvalid(activity?.provider)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3 text-black">
                <Col xs={9}>
                    <FormGroup
                        key={`activity[${index}].speakers`}
                        controlId={`activity[${index}].speakers`}
                    >
                        <Form.Label className="h4">Speakers</Form.Label>
                        <Form.Control
                            name="speakers"
                            value={activity?.speakers || ''}
                            onChange={handleOnChange}
                            required
                            isValid={checkValid(activity?.speakers)}
                            isInvalid={checkInvalid(activity?.speakers)}
                        />
                    </FormGroup>
                </Col>
                <Col xs={3}>
                    <FormGroup
                        key={`activity[${index}].relatedCreditsHours`}
                        controlId={`activity[${index}].relatedCreditsHours`}
                    >
                        <Form.Label className="h4">Related Credits/Hours</Form.Label>
                        <Form.Control
                            name="relatedCreditsHours"
                            value={activity?.relatedCreditsHours || ''}
                            onChange={handleOnChangeNumber}
                            type="number"
                            min={1}
                            required
                            isValid={
                                activity?.relatedCreditsHours !== undefined &&
                                activity?.relatedCreditsHours > 0
                            }
                            isInvalid={
                                activity?.relatedCreditsHours !== undefined &&
                                activity?.relatedCreditsHours < 1
                            }
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3 text-black">
                <Col xs={3}>
                    <FormGroup
                        key={`activity[${index}].specificEmdrCredits`}
                        controlId={`activity[${index}].specificEmdrCredits`}
                    >
                        <Form.Label className="h4">Specific EMDR Credits</Form.Label>
                        <Form.Control
                            name="specificEmdrCredits"
                            value={activity?.specificEmdrCredits || ''}
                            onChange={handleOnChangeNumber}
                            type="number"
                            min={1}
                            required
                            isValid={
                                activity?.specificEmdrCredits !== undefined &&
                                activity?.specificEmdrCredits > 0
                            }
                            isInvalid={
                                activity?.specificEmdrCredits !== undefined &&
                                activity?.specificEmdrCredits < 1
                            }
                        />
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ActivityEntry;
